/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 * Router configuration for Wizard Order template with mode "Create"
 *
 * @author Evgeniy Naumov
 * @version 1.22.0
 * @since 1.22.0
 */

import { EBreadCrumbType } from '../../modules/breadCrumbs/breadCrumbsTypes';
import { IAppRouterConfiguration } from '../appRouterTypes';
import { RoutePath } from './routesConstants';

export const WizardOrderTemplateCreateConfiguration: IAppRouterConfiguration[] = [
    {
        path: RoutePath.wizardOrderTemplateCreateFromDashbord,
        breadCrumbs: [EBreadCrumbType.reportsConstructor, EBreadCrumbType.wizardOrderTemplateCreate],
    },
    {
        path: RoutePath.wizardOrderTemplateCreateFromAccount,
        breadCrumbs: [
            EBreadCrumbType.accounts,
            EBreadCrumbType.accountId,
            EBreadCrumbType.reportsConstructorFromAccount,
            EBreadCrumbType.wizardOrderTemplateCreate,
        ],
    },
    {
        path: RoutePath.wizardOrderTemplateCreateFromAccountList,
        breadCrumbs: [
            EBreadCrumbType.accounts,
            EBreadCrumbType.reportsConstructorFromAccountList,
            EBreadCrumbType.wizardOrderTemplateCreate,
        ],
    },
    {
        path: RoutePath.wizardOrderTemplateCreateFromMobileList,
        breadCrumbs: [
            EBreadCrumbType.subscriberMobile,
            EBreadCrumbType.reportsConstructorFromMobileList,
            EBreadCrumbType.wizardOrderTemplateCreate,
        ],
    },
    {
        path: RoutePath.wizardOrderTemplateCreateFromAutoReports,
        breadCrumbs: [
            EBreadCrumbType.settingsAutoReports,
            EBreadCrumbType.reportsConstructorFromAutoReports,
            EBreadCrumbType.wizardOrderTemplateCreate,
        ],
    },
];
